<div class="container-fluid">
    <div class="row align-items-left">
        <div class="col-4">
            <p class="mb-1 browserTitle">Información del navegador</p>
        </div>
        <ul class="ulList">
            <li>
                <p>
                    <strong> Navegador:</strong> {{ deviceInfo.browser}}
                </p>
            </li>
            <li>
                <p>
                    <strong>Versión navegador:</strong> {{ deviceInfo.browser_version}}
                </p>
            </li>
            <li>
                <p>
                    <strong>Dispositivo:</strong> {{ isDesktopvar ? 'Escritorio' : 'Otro' }}
                </p>
            </li>
            <li>
                <p>
                    <strong>Sistema operativo:</strong> {{ deviceInfo.os}}
                </p>
            </li>
            <li>
                <p>
                    <strong> Versión sistema operativo:</strong> {{ deviceInfo.os_version}}
                </p>
            </li>
            <li>
                <p>
                    <strong> Fecha:</strong> {{ newDate}}
                </p>
            </li>
            <li>
                <p>
                    <strong> UserAgent:</strong> {{ deviceInfo.userAgent}}
                </p>
            </li>
            <li>
                <p>
                    <strong> IP Pública:</strong> {{publicIP}}
                </p>
            </li>
            <li>
                <p>
                    <strong> IP Privada:</strong> {{privateIP}}
                </p>
            </li>
        </ul>
    </div>
    <hr class="verticalLine">
</div>
<!-- <div class="container-fluid rowMs">
    <div class="row justify-content-between">
        <div class="col-4">
            <p class="mb-1 microserviceTitle">Salud de los microservicios</p>
        </div>
        <div *ngIf="(smOrderHealth && smSmanagerHealth && smProductHealth && smCustomerHealth && smUpublicHealth && smTdocHealth && smVendorHealth) === true; else errorGif"
            class="col-4">
            <img src="../../assets/beat_nuevo.gif" class="gif" alt="">
        </div>
        <ng-template #errorGif>
            <div class="col-4">
                <img src="../../assets/noBeat.gif" class="gif" alt="">
            </div>
        </ng-template>

    </div>
    <hr class="verticalLineBottom">
    <div class="row msRow">
        <div class="row align-items-start text-center">
            <div class="col" *ngIf="smOrderHealth; else negativeOrder">
                <strong>Activo</strong>
                <p>Microservicio Order</p>
            </div>
            <ng-template #negativeOrder>
                <div class="col">
                    <strong>Inactivo</strong>
                    <p>Microservicio Order</p>
                </div>
            </ng-template>
            <div class="col" *ngIf="smSmanagerHealth; else negativeManager">
                <strong>Activo</strong>
                <p>Microservicio S. manager</p>
            </div>
            <ng-template #negativeManager>
                <div class="col">
                    <strong>Inactivo</strong>
                    <p>Microservicio S. manager</p>
                </div>
            </ng-template>
            <div class="col" *ngIf="smProductHealth; else negativeProduct">
                <strong>Activo</strong>
                <p>Microservicio Product</p>
            </div>
            <ng-template #negativeProduct>
                <div class="col">
                    <strong>Inactivo</strong>
                    <p>Microservicio Product</p>
                </div>
            </ng-template>
            <div class="col" *ngIf="smCustomerHealth; else negativeCustomer">
                <strong>Activo</strong>
                <p>Microservicio Customer</p>
            </div>
            <ng-template #negativeCustomer>
                <div class="col">
                    <strong>Inactivo</strong>
                    <p>Microservicio Customer</p>
                </div>
            </ng-template>
            <div class="col" *ngIf="smUpublicHealth; else negativePublic">
                <strong>Activo</strong>
                <p>Microservicio Utils Public</p>
            </div>
            <ng-template #negativePublic>
                <div class="col">
                    <strong>Inactivo</strong>
                    <p>Microservicio Utils Public</p>
                </div>
            </ng-template>
            <div class="col" *ngIf="smTdocHealth; else negativeDoc">
                <strong>Activo</strong>
                <p>Microservicio Tributary Doc</p>
            </div>
            <ng-template #negativeDoc>
                <div class="col">
                    <strong>Inactivo</strong>
                    <p>Microservicio Tributary Doc</p>
                </div>
            </ng-template>
            <div class="col" *ngIf="smVendorHealth; else negativeVendor">
                <strong>Activo</strong>
                <p>Microservicio Vendor</p>
            </div>
            <ng-template #negativeVendor>
                <div>
                    <strong>Inactivo</strong>
                    <p>Microservicio Vendor</p>
                </div>
            </ng-template>
        </div>
    </div>
</div> -->
<div *ngIf="loadingHealth && loadingVersion; else spin" class="container-fluid rowMs">
    <div class="row justify-content-between">
        <div class="col-4">
            <p class="mb-1 microserviceTitle">Salud de los microservicios</p>
        </div>
        <div *ngIf="msHealth; else errorGif" class="col-4">
            <img src="../../assets/beat_nuevo.gif" class="gif" alt="">
        </div>
        <ng-template #errorGif>
            <div class="col-4">
                <img src="../../assets/noBeat.gif" class="gif" alt="">
            </div>
        </ng-template>

    </div>
    <hr class="verticalLineBottom">
    <div class="row msRow">
        <div class="row align-items-start text-center">
            <div *ngFor="let ms of msNames; let i = index" class="col">

                <strong *ngIf="msArrHealth[i].status === 'UP'; else negative">Activo</strong>
                <ng-template #negative>
                    <strong> Inactivo</strong>
                </ng-template>
                <p>Microservicio {{ms}}</p>
                <p>Vs: {{msArrVersion[i].app.version}}</p>

            </div>
        </div>
    </div>
</div>

<ng-template #spin>
    <div class="container row spinner d-flex justify-content-center align-items-center">
        <i class="fa fa-spinner fa-spin fa-fw fa-lg"></i>
        <span *ngIf="msg" class="ml-2">{{msg}}</span>
    </div>
</ng-template>